import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ImageComponent } from '@libs/common/components';
import { TextMediaContentModel } from '@libs/cms/models';
import { ContentLinkDirective, HtmlDataLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-text-media',
  templateUrl: './text-media.component.html',
  styleUrls: [
    './text-media.component.scss',
    './text-media.component.lekkerland-2026.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    HeadlinesComponent,
    NgClass,
    ContentLinkDirective,
    HtmlDataLinkDirective,
    MatButton,
  ],
  host: {
    '[class]': '"background-" + data().view.background',
  },
})
export class TextMediaComponent extends ContentBaseComponent<TextMediaContentModel> {
}
